export const GET_PRODUCT_CATEGORY_LIST_REQUEST =
  "get_product_category_list_request";
export const GET_PRODUCT_CATEGORY_LIST_RESPONSE =
  "get_product_category_list_response";

export const ADD_PRODUCT_CATEGORY_REQUEST = "add_product_category_request";
export const ADD_PRODUCT_CATEGORY_RESPONSE = "add_product_category_response";

export const UPDATE_PRODUCT_CATEGORY_BY_PRODUCT_CATEGORY_ID_REQUEST =
  "update_product_category_by_product_category_id_request";
export const UPDATE_PRODUCT_CATEGORY_BY_PRODUCT_CATEGORY_ID_RESPONSE =
  "update_product_category_by_product_category_id_response";

export const DELETE_PRODUCT_CATEGORY_BY_PRODUCT_CATEGORY_ID_REQUEST =
  "delete_product_category_by_product_category_id_request";
export const DELETE_PRODUCT_CATEGORY_BY_PRODUCT_CATEGORY_ID_RESPONSE =
  "delete_product_category_by_product_category_id_response";

export const UPDATE_PRODUCT_CATEGORY_STATUS_BY_PRODUCT_CATEGORY_ID_REQUEST =
  "update_product_category_status_by_product_category_id_request";
export const UPDATE_PRODUCT_CATEGORY_STATUS_BY_PRODUCT_CATEGORY_ID_RESPONSE =
  "update_product_category_status_by_product_category_id_response";
